import React, { useCallback, useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import DescargaFormulario from '../Formulario';

const DescargaDetalhesMain = () => {
  const history = useHistory();
  const location = useLocation();
  const descarga = location.state?.descarga || null;
  const returnPath = location.state?.returnPath || '/pages/descarga/descargas';

  const identificador = useMemo(() => {
    if (!descarga) return '';
    return descarga.numeroCarga && descarga.numeroCarga !== '-'
      ? descarga.numeroCarga
      : descarga.protocoloCarga || descarga.codigoCarga || '';
  }, [descarga]);

  const handleVoltar = useCallback(() => {
    if (location.state?.returnPath) {
      history.push(returnPath);
      return;
    }

    history.goBack();
  }, [history, location.state, returnPath]);

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[
              { name: 'Inicio' },
              { name: 'Descarga', route: '/pages/descarga/descargas' },
              { name: 'Detalhes' }
            ]}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <HeaderWrap>
                <div>
                  <Titulo>Detalhes da Descarga</Titulo>
                  {identificador ? <Subtitulo>{identificador}</Subtitulo> : null}
                </div>
                <ButtonContainer>
                  <ButtonWithLoading variant="outline-secondary" onClick={handleVoltar}>
                    Voltar
                  </ButtonWithLoading>
                </ButtonContainer>
              </HeaderWrap>

              {!descarga ? (
                <EmptyState>
                  Nao foi possivel carregar os detalhes desta descarga. Acesse os detalhes a partir da listagem.
                </EmptyState>
              ) : (
                <DescargaFormulario
                  descarga={descarga}
                  readOnly
                />
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default DescargaDetalhesMain;

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const Titulo = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
`;

const Subtitulo = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 14px;
  color: #6c757d;
`;

const EmptyState = styled.div`
  padding: 32px 16px;
  text-align: center;
  color: #6c757d;
  background: #f8f9fa;
  border: 1px solid #edf0f2;
`;
